export const INSTALLED_AT_INFO_REQUEST = 'INSTALLED_AT_INFO_REQUEST';
export const INSTALLED_AT_INFO_SUCCESS = 'INSTALLED_AT_INFO_SUCCESS';
export const INSTALLED_AT_INFO_FAILURE = 'INSTALLED_AT_INFO_FAILURE';

export const INSTALLED_AT_INFO_SAVE_REQUEST = 'INSTALLED_AT_INFO_SAVE_REQUEST';
export const INSTALLED_AT_INFO_SAVE_SUCCESS = 'INSTALLED_AT_INFO_SAVE_SUCCESS';
export const INSTALLED_AT_INFO_SAVE_FAILURE = 'INSTALLED_AT_INFO_SAVE_FAILURE';

export const VERIFY_INSTALLED_AT_INFO_REQUEST = 'VERIFY_INSTALLED_AT_INFO_REQUEST';
export const VERIFY_INSTALLED_AT_INFO_SUCCESS = 'VERIFY_INSTALLED_AT_INFO_SUCCESS';
export const VERIFY_INSTALLED_AT_INFO_FAILURE = 'VERIFY_INSTALLED_AT_INFO_FAILURE';
